export default __webpack_public_path__ + "static/media/essays.bbd8e656.png";